var exports = {
  "k": "container__W45oI6",
  "o": "compact__A9b6qM",
};

module.exports = exports;
